import React from 'react';

import fileIcon from '@assets/img/icons/file.svg';
import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  fileLink: {
    ...common.link,
    ...common.baseButton,
  },
  fileIcon: {
    ...common.textPrimary,
    marginRight: 6,
    position: 'relative',
    top: 2,
  },
  fileLinkGrayBlock: {
    ...common.middleText,
    wordBreak: 'break-all',
    padding: '0.25rem 0.5rem',
    display: 'block',
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[100],
  },
}));

export interface FileLinkProps {
  href?: string;
  className?: string;
  download?: boolean;
  variant?: 'gray-block';
  onClick?: () => void;
}

export const FileLink: React.FC<React.PropsWithChildren<FileLinkProps>> = React.memo((props) => {
  const { href, className, children, download = true, onClick, variant } = props;

  const classes = useStyles();

  return (
    <a href={href} target="_blank" rel="noreferrer" download={download} onClick={onClick}>
      <span
        className={clsx(
          classes.fileLink,
          className,
          variant === 'gray-block' && classes.fileLinkGrayBlock,
        )}
      >
        <img src={fileIcon} alt="File" className={classes.fileIcon} />

        {children}
      </span>
    </a>
  );
});
